import { Scopes } from "./scopes.enum";
import strings from "../core/translate";

// Scopes are "<resource>:<action>" strings. The permission editors show one row
// per resource with a checkbox per action, so group them here once.
const LABELS = () => ({
  me: strings.user,
  users: strings.user_list,
  merchants: strings.merchant,
  "merchants-users": strings.merchant_users,
  "merchants-branches": strings.garages,
  // the services a garage offers: this is what the "Services" menu entry
  // follows, so it must not be called plain "Services" here — the catalogue
  // below used to carry that name and got unticked in its place
  "merchants-branches-services": strings.garage_services,
  "merchants-branches-photos": strings.branch_photos,
  "merchants-branches-ratings": strings.branch_ratings,
  "merchants-branches-service-details": strings.branch_service_details,
  "merchants-branches-appointments": strings.appointments,
  "merchants-branches-appointments-settings": strings.appointment_settings,
  "merchants-branches-appointments-bookings": strings.appointment_bookings,
  "merchants-branches-offers": strings.offers,
  "merchants-workers": strings.merchant_workers,
  "merchants-items": strings.merchant_items,
  "merchants-subitems": strings.merchant_subitems,
  "merchants-jobs": strings.merchant_jobs,
  cities: strings.cities_management,
  // the admin-wide list of service types, not a garage's own services
  services: strings.service_catalogue,
  "customers-users": strings.customer_users,
  "customers-vehicles": strings.customer_vehicles,
  "customers-vehicles-trims-makes-models": strings.vehicle_model_trims,
  "vehicles-makes": strings.vehicle_makes,
  notifications: strings.notifications,
  banners: strings.banners,
  offers: strings.offers,
  "work-orders": strings.work_orders,
  currencies: strings.currencies,
  "delivery-methods": strings.delivery_methods,
});

const prettify = (resource) =>
  resource
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const ACTION_READ = "read";
export const ACTION_WRITE = "write";

export const getScopeGroups = () => {
  const labels = LABELS();
  const groups = new Map();

  Object.values(Scopes).forEach((scope) => {
    const separator = scope.indexOf(":");
    const resource = separator === -1 ? scope : scope.slice(0, separator);
    const action = separator === -1 ? ACTION_READ : scope.slice(separator + 1);

    if (!groups.has(resource)) {
      groups.set(resource, {
        resource,
        label: labels[resource] || prettify(resource),
        actions: {},
      });
    }
    groups.get(resource).actions[action] = scope;
  });

  return Array.from(groups.values()).sort((a, b) =>
    a.label.localeCompare(b.label)
  );
};

// actions beyond plain read/write, e.g. merchants:read-all
export const extraActions = (group) =>
  Object.keys(group.actions).filter(
    (action) => action !== ACTION_READ && action !== ACTION_WRITE
  );

export const allScopes = () => Object.values(Scopes);
